import Session from "./benthosPages/session/Session";
import Graph from "./benthosPages/editor/graph/Graph";
import Organisation from "./benthosPages/organisation/Organisation";
import Config from "./benthosPages/editor/config/Config";
import Bloblang from "./benthosPages/editor/bloblang/Bloblang";
import { Devices } from "./S3files/Devices";
import OrganizationList from "./S3files/Organization";
import EditNodes from "./benthosPages/EditNodes";
import ProjectsList from "./projects/ProjectsList";
import InteractiveList from "./S3files/files";
import {
  BookPlus,
  Factory,
  Gauge,
  Home,
  ListTodo,
  LucideIcon,
  MonitorSmartphone,
  Settings,
  Users,
} from "lucide-react";
import UsersList from "./pages/Users";
import DeviceCustomFunction from "./S3files/DeviceCustomFunction";
import { Dashboard } from "./pages/Dashboard";

interface Route {
  path: string;
  title: string;
  icon?: LucideIcon; // Specify that the icon is a LucideIcon
  exact: boolean;
  element: React.FC | React.ElementType;
  access: string[]; // Array of roles or access types (e.g., ["*"] for all roles)
  showOnSidebar: boolean;
}
export const routes: Route[] = [
  {
    title: "Home",
    icon: Home,
    path: "/",
    exact: true,
    element: Dashboard,
    access: ["*"],
    showOnSidebar: true,
  },
  {
    title: "Organisations",
    icon: Factory,
    path: "/org",
    exact: true,
    element: OrganizationList,
    access: ["*"],
    showOnSidebar: true,
  },
  {
    title: "Users",
    path: "/users",
    exact: true,
    element: UsersList,
    access: ["Admin"],
    icon: Users,
    showOnSidebar: true,
  },
  {
    title: "Projects",
    icon: ListTodo,
    path: "/project-list",
    exact: true,
    element: ProjectsList,
    access: ["*"],
    showOnSidebar: true,
  },
  {
    title: "Firmwares",
    icon: BookPlus,
    path: "/firmwares",
    exact: true,
    element: InteractiveList,
    access: ["*"],
    showOnSidebar: true,
  },
  {
    title: "Devices",
    icon: MonitorSmartphone,
    path: "/devices",
    exact: true,
    element: Devices,
    access: ["*"],
    showOnSidebar: true,
  },
  {
    title: "Custom Functions",
    icon: Settings,
    path: "/devices-custom-functions",
    exact: true,
    element: DeviceCustomFunction,
    access: ["*"],
    showOnSidebar: true,
  },
  {
    title: "Session",
    path: "/app/view/s/:sessionID",
    exact: true,
    element: Session,
    access: ["*"],
    showOnSidebar: false,
  },
  {
    title: "Graph",
    path: "/app/view/s/:sessionID/:fileName/graph",
    exact: true,
    element: Graph,
    access: ["*"],
    showOnSidebar: false,
  },
  {
    title: "File Run",
    path: "/app/view/s/:sessionID/:fileName/run",
    exact: true,
    element: Graph,
    access: ["*"],
    showOnSidebar: false,
  },
  {
    title: "Organisation Detail",
    path: "/app/view/o/:organisationID",
    exact: true,
    element: Organisation,
    access: ["*"],
    showOnSidebar: false,
  },

  {
    title: "Edit Nodes",
    path: "/edit-nodes",
    exact: true,
    element: EditNodes,
    access: ["*"],
    showOnSidebar: false,
  },

  {
    title: "File Config",
    path: "/app/view/s/:sessionID/:fileName/config",
    exact: true,
    element: Config,
    access: ["*"],
    showOnSidebar: false,
  },
  {
    title: "File",
    path: "/app/view/s/:sessionID/:fileName/blobl",
    exact: true,
    element: Bloblang,
    access: ["*"],
    showOnSidebar: false,
  },
];
